import {
  Card,
  Input, Row
} from 'reactstrap';
import 'rsuite/dist/rsuite.css';
import search from "../../assets/images/search.png";
import { useState, useEffect, useRef } from 'react';
import 'react-datetime/css/react-datetime.css';
import 'bootstrap/dist/css/bootstrap.css';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import PaginationTable from '../../components/status/PaginationTable';
import "./index.css";
  
import axiosInstance from '../../helpers/axios';
import { useCurrentUser } from '../../hooks/useCurrentUser';
  
  require('moment/locale/fr');
  require('moment/locale/de');
  require('moment/locale/en-gb');
  
  const TemplateData = () => {
  const decode = useCurrentUser();
    
      
    //filter
    const [instituteName, setInstituteName] = useState('');
    const [studentName, setStudentName] = useState('');
    const [phone, setPhone] = useState('');
    const [isLoading, setIsLoading] = useState(true); 
    const [activePage, setActivePage] = useState(15); 
    //table
    const [tableData, setTableData] = useState([]);
   
    //pagination
    const [currentPage, setcurrentPage] = useState(1);
    const [rowsPerPage, setrowsPerPage] = useState(15);
    const [totalFetchRows, setTotalFetchRows] = useState(null);

    const dataUrl = `excel/get-uploaded-data`
    useEffect(() => {
        let queryParams = {}

        if(instituteName){
          queryParams.instituteName = instituteName;
        }
        if(studentName){
          queryParams.studentName = studentName;
        }
        if(phone){
            queryParams.phone = phone;
        }

        axiosInstance.get(dataUrl, {
          params:queryParams
        }).then((res)=>{
            setTableData(res?.data?.data?.data?.rows);
            setcurrentPage(res?.data?.data?.pagination?.currentPage);
            setTotalFetchRows(res?.data?.data?.pagination?.totalRows);
            setrowsPerPage(res?.data?.data?.pagination?.perPage);
            setIsLoading(false)
        }).catch((err)=>{
        })
     
    }, [dataUrl]);
    const clearDateFilter =()=>{
        setInstituteName('');
        setStudentName('');
        setPhone('');
        window.location.reload()
        let queryParams = {}

        if(instituteName){
            queryParams.instituteName = instituteName;
        }
        if(studentName){
            queryParams.studentName = studentName;
        }
        if(phone){
            queryParams.phone = phone;
        }

        axiosInstance.get(dataUrl, {
            params:queryParams
        }).then((res)=>{
            setTableData(res?.data?.data?.data?.rows);
            setcurrentPage(res?.data?.data?.pagination?.currentPage);
            setTotalFetchRows(res?.data?.data?.pagination?.totalRows);
            setrowsPerPage(res?.data?.data?.pagination?.perPage);
            setIsLoading(false)
        }).catch((err)=>{
        })
        }

    const handlepageChange = (number) => {
        setIsLoading(true)
        setActivePage(number)
        setrowsPerPage(number);
    
        let queryParams = {}

        if(instituteName){
            queryParams.instituteName = instituteName;
        }
        if(studentName){
            queryParams.studentName = studentName;
        }
        if(phone){
            queryParams.phone = phone;
        }
        if(rowsPerPage && currentPage){
            queryParams.perPage = number;
            queryParams.pageNo = currentPage
          }


        axiosInstance.get(dataUrl, {
            params:queryParams
        }).then((res)=>{
            setTableData(res?.data?.data?.data?.rows);
            setcurrentPage(res?.data?.data?.pagination?.currentPage);
            setTotalFetchRows(res?.data?.data?.pagination?.totalRows);
            setrowsPerPage(res?.data?.data?.pagination?.perPage);
            setIsLoading(false)
        }).catch((err)=>{
        })
    };
    const handleInputChange = () => {
        setIsLoading(true)
        let queryParams = {}

        if(instituteName){
            queryParams.instituteName = instituteName;
        }
        if(studentName){
            queryParams.studentName = studentName;
        }
        if(phone){
            queryParams.phone = phone;
        }
        if(rowsPerPage && currentPage){
            queryParams.perPage = rowsPerPage;
            queryParams.pageNo = currentPage
          }

        axiosInstance.get(dataUrl, {
            params:queryParams
        }).then((res)=>{
            setTableData(res?.data?.data?.data?.rows);
            setcurrentPage(res?.data?.data?.pagination?.currentPage);
            setTotalFetchRows(res?.data?.data?.pagination?.totalRows);
            setrowsPerPage(res?.data?.data?.pagination?.perPage);
            setIsLoading(false)
        }).catch((err)=>{
        })
    };
    const paginate = (pageNumber) => {
    
      setcurrentPage(pageNumber);
      let queryParams = {}

        if(instituteName){
            queryParams.instituteName = instituteName;
        }
        if(studentName){
            queryParams.studentName = studentName;
        }
        if(phone){
            queryParams.phone = phone;
        }
        if(rowsPerPage && currentPage){
            queryParams.perPage = rowsPerPage;
            queryParams.pageNo = pageNumber
          }

        axiosInstance.get(dataUrl, {
            params:queryParams
        }).then((res)=>{
            setTableData(res?.data?.data?.data?.rows);
            setcurrentPage(res?.data?.data?.pagination?.currentPage);
            setTotalFetchRows(res?.data?.data?.pagination?.totalRows);
            setrowsPerPage(res?.data?.data?.pagination?.perPage);
            setIsLoading(false)
        }).catch((err)=>{
        })

    };
    const fileInputRef = useRef(null); // Reference to file input
    const [uploading, setUploading] = useState(false);
  
    const handleFileChange = async (event) => {
        const selectedFile = event.target.files[0];
    
        if (selectedFile) {
          const fileType = selectedFile.type;
          if (
            fileType ===
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
            fileType === "application/vnd.ms-excel"
          ) {
            await uploadFile(selectedFile);
          } else {
            alert("Only Excel files (.xlsx, .xls) are allowed.");
            event.target.value = ""; // Reset file input
          }
        }
      };
    
      const uploadFile = async (file) => {
        setUploading(true);
        const formData = new FormData();
        formData.append("template", file, file.name);
    
        try {
          const response = await fetch(`${process.env.REACT_APP_BASE_URL}/excel/upload`, {
            method: "POST",
            headers: {
              accept: "application/json",
            },
            body: formData,
          });
    
          if (response.ok) {
            alert("File uploaded successfully!");
            window.location.reload()
          } else {
            alert("Failed to upload file.");
          }
        } catch (error) {
          console.error("Error uploading file:", error);
          alert("Error uploading file. Please try again.");
        } finally {
          setUploading(false);
        }
      };
    
      const handleButtonClick = () => {
        fileInputRef.current.click(); 
      };

      const downloadExcel = ()=>{
        axiosInstance.get(`${process.env.REACT_APP_BASE_URL}/file/url-content?path=CampaignData.xlsx`)
        .then((res)=>{
            window.open(res?.data?.data,"_blank")
        }).catch((err)=>{
        })
      }
  
    if (tableData) {

      return (
        <Card className='card' style={{overflowX: 'hidden',width:"100%",height:'100%'}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',paddingTop:'1em',paddingBottom:'2em'}}>
            <div>
      <button
        onClick={handleButtonClick}
        style={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#D22129",
          height: "34px",
          border: "none",
          borderRadius: "5px",
          color: "white",
          fontFamily: "Inter-Medium",
          paddingLeft: "10px",
          paddingRight: "10px",
          cursor: "pointer",
        }}
      >
        <CloudUploadIcon style={{ marginRight: "10px" }} />
        {uploading ? "Uploading..." : "Upload Data"}
      </button>
      <input
        type="file"
        accept=".xls,.xlsx"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: "none" }}
      />
    </div>        
     <button style={{display: 'flex', alignItems: 'center',width:'100px',backgroundColor:'#D22129',height:'34px',borderStyle:'none',borderRadius:"5px",color:'white',fontFamily:"Inter-Medium",paddingLeft:'10px',marginRight:'10px'}} onClick={downloadExcel}><CloudDownloadIcon style={{marginRight:'10px'}}/> Excel</button>
          </div>
          <Row>
            <div style={{ display: 'flex', flex: 'wrap',justifyContent:'space-between',alignItems:'center'}}>
              <Input
                type="text"
                id="userSearch"
                placeholder={'Institute Name'
                }                onChange={(event) => setInstituteName(event.target.value)}
                style={{
                   fontSize: '0.8vw',
                  paddingLeft: '26px',
                  fontFamily: 'Inter-Medium',
                  backgroundImage: `url(${search})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '5px center',
                  backgroundSize: '15px 15px',
                  paddingRight: '5px', 
                  borderColor:'#cccccc',
                  borderStyle:'solid',
                  borderRadius:"5px",
                  borderWidth:'1px',
                  width:'250px'
                }}
              />
             
              <Input
                type="text"
                id="userSearch"
                placeholder={'Student Name'
                }                onChange={(event) => setStudentName(event.target.value)}
                style={{
                   fontSize: '0.8vw',
                  paddingLeft: '26px',
                  fontFamily: 'Inter-Medium',
                  backgroundImage: `url(${search})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '5px center',
                  backgroundSize: '15px 15px',
                  paddingRight: '5px', 
                  borderColor:'#cccccc',
                  borderStyle:'solid',
                  borderRadius:"5px",
                  borderWidth:'1px',
                  width:'250px'
                }}
              />
              <Input
                type="text"
                id="userSearch"
                placeholder={'Mobile'
                }                onChange={(event) => setPhone(event.target.value)}
                style={{
                   fontSize: '0.8vw',
                  paddingLeft: '26px',
                  fontFamily: 'Inter-Medium',
                  backgroundImage: `url(${search})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '5px center',
                  backgroundSize: '15px 15px',
                  paddingRight: '5px', 
                  borderColor:'#cccccc',
                  borderStyle:'solid',
                  borderRadius:"5px",
                  borderWidth:'1px',
                  width:'250px'
                }}
              />
              <button style={{display: 'flex', alignItems: 'center',width:'130px',backgroundColor:'#D22129',height:'34px',borderStyle:'none',borderRadius:"5px",color:'white',fontFamily:"Inter-Medium",paddingLeft:'10px'}}
                  
                 onClick={()=>handleInputChange()}
                >
                  Search Results
                </button>
              <button style={{display: 'flex', alignItems: 'center',width:'100px',backgroundColor:'#D22129',height:'34px',borderStyle:'none',borderRadius:"5px",color:'white',fontFamily:"Inter-Medium",paddingLeft:'10px',marginRight:'10px'}}
                  
                 onClick={()=>clearDateFilter()}
                >
                 Clear Filter
                </button>
               
              {/* <Col>
              <div>
                <button style={{width:'100px',backgroundColor:'gray',height:'36.5px',borderStyle:'none',borderRadius:"5px",color:'white',fontFamily:"Inter-Medium"}} onClick={() => handleClearFilter()} color="primary">
                  Clear Filter
                </button>
                </div>
              </Col> */}
             
            </div>
          </Row>
  
           {isLoading ? (
             <Box style={{ display: 'flex',alignItems:'center',justifyContent:'center',padding:'15%',backgroundColor:'white',height:'100vh'}}>
             <CircularProgress />
           </Box>
           ):(
            <>
           <div className='tables' style={{ marginTop: '20px', width: '100%' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead className='table-heading'>
                <tr>
                    <th style={{ fontSize: '14px', fontFamily: "Inter", width: '20%' }}>Student Name</th>
                    <th style={{ fontSize: '14px', fontFamily: "Inter", width: '20%' }}>Mobile</th>
                    <th style={{ fontSize: '14px', fontFamily: "Inter", width: '15%' }}>Fees</th>
                    <th style={{ fontSize: '14px', fontFamily: "Inter", width: '25%' }}>Institute Name</th>
                    <th style={{ fontSize: '14px', fontFamily: "Inter", width: '20%', whiteSpace: 'nowrap' }}>Created Date</th>
                </tr>
                </thead>
                <tbody>
                {tableData?.map((item, index) => (
                    <tr className="table-row" key={index} style={{ lineHeight: '20px',borderBottom: "1px solid #cccccc93"}}>
                    <td style={{  fontFamily: "Inter", padding: '10px',fontWeight:'400',fontSize:'14px' }}>{item?.studentName}</td>
                    <td style={{  fontFamily: "Inter", padding: '10px',fontWeight:'400',color:'#667085',fontSize:'14px' }}>{item?.phone}</td>
                    <td style={{  fontFamily: "Inter", padding: '10px',fontWeight:'400',color:'#667085',fontSize:'14px' }}>{item?.courseFee}</td>
                    <td style={{  fontFamily: "Inter", padding: '10px',fontWeight:'400',color:'#667085',fontSize:'14px' }}>{item?.instituteName}</td>
                    <td style={{  fontFamily: "Inter", padding: '10px', whiteSpace: 'nowrap' ,fontWeight:'400',color:'#667085',fontSize:'14px'}}>
                        {item?.createdAt.substring(0, 10)}
                    </td>
                    </tr>
                ))}
                </tbody>
            </table>
            </div>


            {totalFetchRows ? ( totalFetchRows <= 100 ?(
                    <div style={{display:"flex" ,justifyContent:"center",marginTop:"10px"}}>
                      <div style={{ textAlign: 'center', fontWeight: 'bold',fontFamily:"Inter", fontSize: '1vw',marginLeft:'10px',marginBottom:'5px' }}>
               
               Showing {currentPage * rowsPerPage + 1 - rowsPerPage}-{currentPage * rowsPerPage - rowsPerPage+tableData?.length}{" "}
                records of {totalFetchRows} |
               
             </div>
            <div style={{display:"flex", justifyContent:"space-between",}}>
            &nbsp;<p style={{fontWeight:'600'}}>Rows Per Pages :</p>
          <div>
          <span onClick={()=>handlepageChange(15)} style={{cursor:'pointer',padding:'10px',color: activePage === 15 ? "#D32028" : "black",backgroundColor:activePage === 15 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>15</span>
          <span onClick={()=>handlepageChange(50)} style={{cursor:'pointer',padding:'10px',color: activePage === 50 ? "#D32028" : "black",backgroundColor:activePage === 50 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>50</span>
          <span onClick={()=>handlepageChange(100)} style={{cursor:'pointer',padding:'10px',color: activePage === 100 ? "#D32028" : "black",backgroundColor:activePage === 100 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>100</span>
          <span onClick={()=>handlepageChange(500)} style={{cursor:'pointer',padding:'10px',color: activePage === 500 ? "#D32028" : "black",backgroundColor:activePage === 500 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>500</span>
          </div>
         
         
          </div>
                      
                    </div>
               
            ):( <div style={{display:"flex",justifyContent:"center",marginTop:"10px"}}><div style={{ textAlign: 'center',fontWeight: 'bold',justifyContent:"space-between",fontFamily:"Inter-Medium", fontSize: '1vw',marginLeft:'10px',marginBottom:'5px',marginRight:'10px'}}>
                
            Showing {currentPage * rowsPerPage + 1 - rowsPerPage}-{currentPage * rowsPerPage - rowsPerPage+tableData?.length} {" "}
            records of {totalFetchRows} |
           
          </div>
          <div style={{display:"flex", justifyContent:"space-between",}}>
            <p style={{fontWeight:'600'}}>Rows Per Pages :</p>
          <div>
          <span onClick={()=>handlepageChange(15)} style={{cursor:'pointer',padding:'10px',color: activePage === 15 ? "#D32028" : "black",backgroundColor:activePage === 15 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>15</span>
          <span onClick={()=>handlepageChange(50)} style={{cursor:'pointer',padding:'10px',color: activePage === 50 ? "#D32028" : "black",backgroundColor:activePage === 50 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>50</span>
          <span onClick={()=>handlepageChange(100)} style={{cursor:'pointer',padding:'10px',color: activePage === 100 ? "#D32028" : "black",backgroundColor:activePage === 100 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>100</span>
          <span onClick={()=>handlepageChange(500)} style={{cursor:'pointer',padding:'10px',color: activePage === 500 ? "#D32028" : "black",backgroundColor:activePage === 500 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>500</span>
          </div>
          </div>
          </div> )
             
            ) : (
              <div style={{ textAlign: 'center', fontWeight: 'bold', fontFamily:"Inter", fontSize: '14px' }}>No Records</div>
            )}
               <PaginationTable
              startPage="1"
              rowsPerPage={rowsPerPage}
              totalRows={totalFetchRows}
              paginate={paginate}
            />
           
            </>

           )}
            


        </Card>
      );
    }
    return <div>....Loading</div>;
  };
  
  export default TemplateData;